import * as React from "react";

/**
 * Symbole des PDF-Editors — eigene Linien-SVGs (20 px, `currentColor`), damit
 * die Leiste ohne `@fluentui/react-icons` auskommt (Plan 02.10.2026, PR 2).
 * Jedes neue Fluent-Symbol musste bisher in vier Editor-Tests nachgemockt
 * werden; diese hier brauchen nichts davon.
 */
const S = ({ children, size = 20 }: { children: React.ReactNode; size?: number }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={1.7}
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden
        focusable="false"
    >
        {children}
    </svg>
);

export const PdfIcons = {
    textHinzu: (
        <S>
            <path d="M4 6h12M10 6v12M14 20h6M17 14v6" />
        </S>
    ),
    zeichnen: (
        <S>
            <path d="M4 20c4-1 5-3 7-7l6-6 2 2-6 6c-4 2-6 3-9 5z" />
            <path d="M14 7l3 3" />
        </S>
    ),
    markieren: (
        <S>
            <path d="M9 13l6-6 3 3-6 6H9v-3z" />
            <path d="M4 20h16" />
        </S>
    ),
    // T-363: „S“ mit Querstrich.
    durchstreichen: (
        <S>
            <path d="M16 6.5C15 5 13.6 4.5 12 4.5c-2.5 0-4 1.3-4 3 0 4 8 2.5 8 7 0 1.8-1.7 3-4 3-1.9 0-3.4-.7-4.3-2" />
            <path d="M3.5 12h17" />
        </S>
    ),
    // T-363: Textzeilen, eine davon als schwarzer Balken.
    schwaerzen: (
        <S>
            <path d="M4 6h16M4 18h10" />
            <rect x="4" y="10" width="16" height="4" fill="currentColor" stroke="none" rx="0.5" />
        </S>
    ),
    unterschrift: (
        <S>
            <path d="M3 17c3-4 5-7 7-7s1 7 3 7 3-6 5-6 2 3 3 3" />
            <path d="M3 21h18" />
        </S>
    ),
    stempel: (
        <S>
            <path d="M9 3h6l-1 7h3a3 3 0 013 3v2H4v-2a3 3 0 013-3h3L9 3z" />
            <path d="M5 19h14" />
        </S>
    ),
    kommentar: (
        <S>
            <path d="M4 5h16v11H9l-5 4V5z" />
            <path d="M12 8v5M9.5 10.5h5" />
        </S>
    ),
    textBearbeiten: (
        <S>
            <path d="M4 6h10M9 6v12" />
            <path d="M15 17l5-5 1 1-5 5h-1v-1z" />
        </S>
    ),
    ausschneiden: (
        <S>
            <circle cx="6.5" cy="17.5" r="2.5" />
            <circle cx="17.5" cy="17.5" r="2.5" />
            <path d="M8.5 15.5L19 4M15.5 15.5L5 4" />
        </S>
    ),
    entfernen: (
        <S>
            <path d="M3 17l8-8 6 6-5 5H8l-5-3z" />
            <path d="M11 9l6 6" />
            <path d="M14 21h7" />
        </S>
    ),
    seiten: (
        <S>
            <path d="M8 4h9l3 3v13H8V4z" />
            <path d="M4 8v13h11" />
            <path d="M17 4v3h3" />
        </S>
    ),
    drehen: (
        <S>
            <path d="M20 12a8 8 0 11-2.3-5.7" />
            <path d="M20 3v5h-5" />
        </S>
    ),
    zoomMinus: (
        <S>
            <circle cx="11" cy="11" r="6" />
            <path d="M16 16l5 5M8 11h6" />
        </S>
    ),
    zoomPlus: (
        <S>
            <circle cx="11" cy="11" r="6" />
            <path d="M16 16l5 5M8 11h6M11 8v6" />
        </S>
    ),
    zoomAnpassen: (
        <S>
            <path d="M4 9V4h5M15 4h5v5M20 15v5h-5M9 20H4v-5" />
        </S>
    ),
    kommentareAn: (
        <S>
            <path d="M4 5h16v11H9l-5 4V5z" />
            <path d="M8 9h8M8 12h5" />
        </S>
    ),
    kommentareAus: (
        <S>
            <path d="M4 5h16v11H9l-5 4V5z" />
            <path d="M3 3l18 18" />
        </S>
    ),
    rueckgaengig: (
        <S>
            <path d="M8 7H4v4" />
            <path d="M4 11a8 8 0 018-8 8 8 0 018 8 8 8 0 01-8 8h-3" />
        </S>
    ),
    wiederholen: (
        <S>
            <path d="M16 7h4v4" />
            <path d="M20 11a8 8 0 00-8-8 8 8 0 00-8 8 8 8 0 008 8h3" />
        </S>
    ),
    speichern: (
        <S>
            <path d="M5 4h11l3 3v13H5V4z" />
            <path d="M8 4v5h7V4M8 20v-6h8v6" />
        </S>
    ),
    schliessen: (
        <S>
            <path d="M6 6l12 12M18 6L6 18" />
        </S>
    ),
    bild: (
        <S>
            <rect x="4" y="5" width="16" height="14" rx="2" />
            <circle cx="9" cy="10" r="1.5" />
            <path d="M20 16l-5-5-7 7" />
        </S>
    ),
    pdf: (
        <S>
            <path d="M6 3h9l4 4v14H6V3z" />
            <path d="M15 3v4h4" />
            <path d="M9 12h6M9 15.5h6M9 8.5h3" />
        </S>
    ),
    bearbeiten: (
        <S>
            <path d="M4 20h4L19 9l-4-4L4 16v4z" />
            <path d="M13.5 6.5l4 4" />
        </S>
    ),
    tabBearbeiten: (
        <S>
            <path d="M18 14v6H4V6h6" />
            <path d="M10 14l1-3.5L18.5 3 21 5.5 13.5 13 10 14z" />
        </S>
    ),
    kommentarOhneStelle: (
        <S>
            <path d="M4 5h16v11H9l-5 4V5z" />
            <path d="M12 8v3.5M12 13.6v.1" />
        </S>
    ),
    fassungen: (
        <S>
            <circle cx="12" cy="12" r="8" />
            <path d="M12 7v5l3 2" />
        </S>
    ),
    herunterladen: (
        <S>
            <path d="M12 4v11M7 10l5 5 5-5" />
            <path d="M4 20h16" />
        </S>
    ),
    neuerTab: (
        <S>
            <path d="M14 4h6v6M20 4l-9 9" />
            <path d="M18 14v6H4V6h6" />
        </S>
    ),
    /** T-216: „Text kopieren“ — zwei Blätter. */
    kopieren: (
        <S>
            <rect x="8" y="8" width="12" height="12" rx="2" />
            <path d="M16 8V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2" />
        </S>
    ),
} as const;

export type PdfIconName = keyof typeof PdfIcons;
